import { React, theme } from "aaa";
import { BackButton } from "../../util/BackButton";
import { A11yRefocus } from "../../common/A11yRefocus";
import { history } from "stores/RouterStore";
import { pushRoute } from "stores/RouterFunctions";

export const SettingsTitleBar = (props: { hideBackButton?: boolean, backRoute?: string, children: any }) => (
    <>
        <div
            className="theme-header-background-color"
            style={{
                width: "100%",
                height: theme.WEB_HEADER_HEIGHT,
                maxWidth: theme.MAX_APP_WIDTH,
                color: "white",
                fontSize: 16,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "fixed",
                top: 0
            }}
        >
            {!props.hideBackButton && (
                <A11yRefocus>
                    <BackButton
                        size={30}
                        offset={{ x: 0, y: 3 }}
                        onClick={() => {
                            if (props.backRoute) {
                                pushRoute(props.backRoute);
                            } else {
                                history.goBack();
                            }
                        }}
                    />
                </A11yRefocus>
            )}
            {props.children}
        </div>
        <div style={{ height: theme.WEB_HEADER_HEIGHT }} />
    </>
);



// WEBPACK FOOTER //
// ./src/components/loginManagement/components/SettingsTitleBar.tsx